import {
  ComponentFactory,
  ComponentFactoryResolver,
  Injectable,
} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ModalService {
  factory: ComponentFactory<unknown> | undefined;

  private _isOpen$: Subject<boolean> = new Subject();
  private _modalConfig: IModalConfig;

  constructor(private resolver: ComponentFactoryResolver) {}

  get isOpen$(): Observable<boolean> {
    return this._isOpen$.asObservable();
  }

  get modalConfig(): IModalConfig | undefined {
    return this._modalConfig;
  }

  open(component: unknown, modalConfig?: IModalConfig): void {
    this._modalConfig = modalConfig;
    this.factory = this.resolver.resolveComponentFactory(component as any);
    this._isOpen$.next(true);
  }

  close(): void {
    this._isOpen$.next(false);
    this._modalConfig = undefined;
    this.factory = undefined;
  }
}

export interface IModalConfig {
  showClose?: boolean;
  width?: string;
}
